<template>
  <v-parallax src="../../assets/fightbanner.jpg" height="200">
  <v-row>
    <v-col class="col-12 my-auto text-center">
      <h2 class="bannerheadingh2">Past Fights</h2>
    </v-col>
  </v-row>
  </v-parallax>
</template>

<script>
export default {

}
</script>

<style lang="sass">
// .bannerheadingh1
//   font-size: 70px
//   text-transform: uppercase

// .bannerheadingh2 
//   font-size: 55px
//   text-transform: uppercase
//   font-weight: bold
</style>